import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index/index'
import subscribe from '@/components/index/subscribe'
import my from '@/components/my/my'
import paydetail from '@/components/paydetail/paydetail'
import success from '@/components/paydetail/success'
import nofeel from '@/components/nofeel/nofeel'
import bindcard from '@/components/nofeel/bindcard'
import CCBprocedure from '@/components/nofeel/CCBprocedure'
import informdetail from '@/components/paydetail/informdetail'
import informdetail2 from '@/components/paydetail/informdetail2'
import instruction from '@/components/menu/instruction'
import accountrecorder from '@/components/my/accountrecorder'
import scan from '@/components/scan'
import invoice from '@/components/invoice/invoice'
import invoicehistory from '@/components/invoice/invoicehistory'
import indetail from '@/components/paydetail/indetail'
import inoutdetail from '@/components/paydetail/inoutdetail'
import recorderdetail from '@/components/my/recorderdetail'
import searchCarIndex from "@/components/searchCar/searchCarIndex"
import searchCarDetail from "@/components/searchCar/searchCarDetail"
import recharge from '@/components/recharge/recharge'
import searchCombo from '@/components/recharge/searchCombo'
import parkingOption from '@/components/recharge/parkingOption'
import discountScan from '@/components/discountScan'
import lockCar from '@/components/lockCar/lockCar'
import lockIndex from '@/components/lockCar/lockIndex'
import login from '@/components/my/login'
import register from '@/components/my/register'
import forgetPassword from '@/components/my/forgetPassword'
import updateAccountInfo from '@/components/my/updateAccountInfo'
import bindCar from '@/components/my/bindCar'
import manageCars from '@/components/my/manageCars'
import recordType from '@/components/my/recordType'
import paymentRecords from '@/components/my/paymentRecords'
import electronicInvoice from '@/components/my/electronicInvoice/index'
import invoiceChoosePark from '@/components/my/electronicInvoice/choosePark'
import invoiceHzhospital from '@/components/my/electronicInvoice/hzhospital'
import invoiceParkingPayRecord from '@/components/my/electronicInvoice/parkingPayRecord'
import giveChange from '@/components/paydetail/giveChange'
import noCarApply from '@/components/my/noCarApply'
import noCarParking from '@/components/my/noCarParking'
import noCarParkingcomm from '@/components/my/noCarParkingcomm'
import { Toast, Dialog  } from 'vant';
Vue.use(Toast,Dialog);
Vue.use(Router)
export default new Router({
routes: [
        { path: '/', redirect: '/index'}, // 默认就跳转此页面
        {
            path : '/index',  //到时候地址栏会显示的路径
            name : 'index',
            component :  index ,  // Home是组件的名字，这个路由对应跳转到的组件。。注意component没有加“s”.
            meta: {
                // 路由层级，数值越大层级越深，以此决定转场动画的前进和后退 大于前进，小于后退
                title: "立即缴费",
                index: 0,
                showFooter: true,
                requireAuth: false,
            }
        },
        {
            path : '/subscribe',  //到时候地址栏会显示的路径
            name : 'subscribe',
            component :  subscribe ,  // Home是组件的名字，这个路由对应跳转到的组件。。注意component没有加“s”.
            meta: {
                // 路由层级，数值越大层级越深，以此决定转场动画的前进和后退 大于前进，小于后退
                title: "关注流程",
                index: 1,
                showFooter: false,
                requireAuth: false,
            }
        },
        {
          path: '/my',
          name: 'my',
          component: my,
          meta: {
            title: "个人中心",
            index: 0,
            showFooter: true,
            requireAuth: false,
          }
        }, {
          path: '/login',
          name: 'login',
          component: login,
          meta: {
            title: "登录",
            index: 0,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/register',
          name: 'register',
          component: register,
          meta: {
            title: "注册",
            index: 0,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/forgetPassword',
          name: 'forgetPassword',
          component: forgetPassword,
          meta: {
            title: "忘记密码",
            index: 0,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/updateAccountInfo',
          name: 'updateAccountInfo',
          component: updateAccountInfo,
          meta: {
            title: "信息变更",
            index: 0,
            showFooter: false,
            requireAuth: true,
          }
        }, {
          path: '/bindCar',
          name: 'bindCar',
          component: bindCar,
          meta: {
            title: "车辆绑定",
            index: 0,
            showFooter: false,
            requireAuth: true,
          }
        }, {
          path: '/manageCars',
          name: 'manageCars',
          component: manageCars,
          meta: {
            title: "车辆管理",
            index: 0,
            showFooter: false,
            requireAuth: true,
          }
        }, {
          path: '/paydetail',
          name: 'paydetail',
          component: paydetail,
          meta: {
            title: "缴费",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/success',
          name: 'success',
          component: success,
          meta: {
            title: "缴费成功",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/nofeel',
          name: 'nofeel',
          component: nofeel,
          meta: {
            title: "无感绑卡",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/bindcard',
          name: 'bindcard',
          component: bindcard,
          meta: {
            title: "绑卡",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/CCBprocedure',
          name: 'CCBprocedure',
          component: CCBprocedure,
          meta: {
            title: "建行绑定流程",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/informdetail',
          name: 'informdetail',
          component: informdetail,
          meta: {
            title: "支付详情",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/informdetail2',
          name: 'informdetail2',
          component: informdetail2,
          meta: {
            title: "支付详情",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/instruction',
          name: 'instruction',
          component: instruction,
          meta: {
            title: "使用说明",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/accountrecorder',
          name: 'accountrecorder',
          component: accountrecorder,
          meta: {
            title: "停车记录",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/recordType',
          name: 'recordType',
          component: recordType,
          meta: {
            title: "开票类型",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/paymentRecords',
          name: 'paymentRecords',
          component: paymentRecords,
          meta: {
            title: "缴费记录",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/electronicInvoice',
          name: 'electronicInvoice',
          component: electronicInvoice,
          meta: {
            title: "电子发票",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/invoiceChoosePark',
          name: 'invoiceChoosePark',
          component: invoiceChoosePark,
          meta: {
            title: "选择停车场",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        },
        {
          path: '/invoiceHzhospital',
          name: 'invoiceHzhospital',
          component: invoiceHzhospital,
          meta: {
            title: "电子发票",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        },
         {
          path: '/invoiceParkingPayRecord',
          name: 'invoiceParkingPayRecord',
          component: invoiceParkingPayRecord,
          meta: {
            title: "电子发票",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/scan',
          name: 'scan',
          component: scan,
          meta: {
            title: "扫码",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/invoice',
          name: 'invoice',
          component: invoice,
          meta: {
            title: "申请发票",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/invoicehistory',
          name: 'invoicehistory',
          component: invoicehistory,
          meta: {
            title: "开票历史",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/indetail',
          name: 'indetail',
          component: indetail,
          meta: {
            title: "账单详情",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/inoutdetail',
          name: 'inoutdetail',
          component: inoutdetail,
          meta: {
            title: "通知详情",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/recorderdetail',
          name: 'recorderdetail',
          component: recorderdetail,
          meta: {
            title: "停车记录详情",
            index: 1,
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/searchCar',
          name: 'searchCar',
          component: searchCarIndex,
          meta: {
            title: "反向寻车",
            index: 0,
            showFooter: true,
            requireAuth: false,
          }
        }, {
          path: '/searchCarDetail',
          name: 'searchCarDetail',
          component: searchCarDetail,
          meta: {
            title: "反向寻车",
            requireAuth: false,
          }
        }, {
          path: '/recharge',
          name: 'recharge',
          component: recharge,
          meta: {
            title: "套餐充值",
            requireAuth: false,
          }
        }, {
          path: '/searchCombo',
          name: 'searchCombo',
          component: searchCombo,
          meta: {
            title: "套餐查询",
            requireAuth: false,
          }
        }, {
          path: '/parkingOption',
          name: 'parkingOption',
          component: parkingOption,
          meta: {
            title: "选择车场",
            requireAuth: false,
          }
        }, {
          path: '/discountScan',
          name: 'discountScan',
          component: discountScan,
          meta: {
            title: "优惠券领取",
            requireAuth: false,
          }
        }, {
          path: '/lockIndex',
          name: 'lockIndex',
          component: lockIndex,
          meta: {
            title: "锁车",
            requireAuth: false,
          }
        }, {
          path: '/lockCar',
          name: 'lockCar',
          component: lockCar,
          meta: {
            title: "锁车",
            requireAuth: false,
          }
        }, {
          path: '/tempPay',
          name: 'tempPay',
          component: index,
          meta: {
            title: "临时缴费",
            showFooter: false,
            requireAuth: false,
          }
        }, {
          path: '/giveChange',
          name: 'giveChange',
          component: giveChange,
          meta: {
            title: "找零领取",
            showFooter: false,
            requireAuth: false,
          }
        },{
          path: '/noCarApply',
          name: 'noCarApply',
          component: noCarApply,
          meta: {
            title: "月卡车辆",
            showFooter: false,
            requireAuth: false,
          }
        },{
          path: '/noCarParking',
          name: 'noCarParking',
          component: noCarParking,
          meta: {
            title: "选择停车场",
            showFooter: false,
            requireAuth: false,
          }
        },{
          path: '/noCarParkingcomm',
          name: 'noCarParkingcomm',
          component: noCarParkingcomm,
          meta: {
            title: "选择社区",
            showFooter: false,
            requireAuth: false,
          }
        },
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js